import { Box, Grid, TextField, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material"
import { regexConstants } from "../../../constants/regEx"

const ProRateDetails = ({ reserveRates, onFieldChange, modeType, error, onFocusChange }) => {
    return (
        <Grid container spacing={1}>
            <Grid size={{ md: 12, xs: 12 }}>
                <Box sx={{ backgroundColor: "#f2f2f2", padding: "0px 12px 12px 12px" }} >
                    <FormControl component="fieldset">
                        <RadioGroup
                            row
                            value={reserveRates?.is_prorated}
                            onChange={(e) => onFieldChange("is_prorated", e.target.value)}
                        >
                            <FormControlLabel
                                value={true}
                                control={<Radio />}
                                label="Fix Days in Month"
                                disabled={modeType === "view"}
                                sx={{ marginLeft: "-10px" }}
                            />
                            <FormControlLabel
                                value={false}
                                control={<Radio />}
                                label="Selected Month"
                                disabled={modeType === "view"}
                                sx={{ marginLeft: "10px" }}
                            />
                        </RadioGroup>
                    </FormControl>
                    {reserveRates?.is_prorated === "true" || reserveRates?.is_prorated === true   ? <Grid size={{ md: 2, xs: 12 }}>
                        <TextField
                            required
                            id="days"
                            value={reserveRates?.days || ''}
                            onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('days', e.target.value) : e.preventDefault() }}
                            onFocus={() => onFocusChange("days")}
                            label="Number of Day's"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            error={!!error.days}
                            helperText={error.days}
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 5 } }}
                            fullWidth
                            disabled={modeType === 'view'}
                        />
                    </Grid> : null}
                </Box>
            </Grid>
        </Grid>
    )
}

export default ProRateDetails